import { render } from "./book-suggests.vue?vue&type=template&id=10de60eb&scoped=true"
import script from "./book-suggests.js?vue&type=script&lang=js&external"
export * from "./book-suggests.js?vue&type=script&lang=js&external"

import "./book-suggests.css?vue&type=style&index=0&id=10de60eb&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10de60eb"]])

export default __exports__